<template>
  <div>
    <l-geo-json
        ref="parkings"
        :geojson="geojson"
        :options="optParking"
    ></l-geo-json>
  </div>
</template>

<script>
import {LGeoJson} from 'vue2-leaflet';
import {marker, divIcon} from "leaflet";


export default {
  name: "Parkings",
  props: ['geojson'],
  data() {
    return {
      optParking: {
        pointToLayer: this.crearParking,

      },
      otpLabels: {
        pointToLayer: this.crearLabel
      },

    }
  },

  methods: {
    crearParking(feature, latlng) {

      return marker(latlng, {
        icon: new divIcon( {
          html: `<div class="marcador-refugio"><i class="text-light parking">P</i></div>`,
          className: 'etiqueta',
          iconSize: [24,24],
          iconAnchor: [12, 12]
        }),
        opacity: 0
      }).bindPopup(`<h5>${feature.properties.name}</h5>`)
    }
  },
  components: {
    LGeoJson
  }
}
</script>

<style>
.leaflet-marker-icon.etiqueta {
  background-color: transparent!important;
  color: black;
  font-size: 18px;
  text-shadow:
      0.7px  0.7px     #fff,
      -0.7px  0.7px     #fff,
      0.7px -0.7px     #fff,
      -0.7px -0.7px     #fff,
      0.7px  0.7px 0.7px #fff;
  font-weight: 700;
  text-align: center;
}
.marcador-refugio {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #212C5C;
}
.marcador-refugio i.parking {
  font-weight: normal;
  padding: 5px;
}
</style>